module.exports = __webpack_public_path__ + "static/media/total-users-blue.357117c9.svg";